/* eslint-disable */
import React from "react";
import { NavLink } from "react-router-dom";
import { RiEyeLine } from "react-icons/ri";
import { BACKEND_URL_PREFIX } from "../../utils/const";
import styles from "./LK.module.css";

export default function LKLinks({ links, isTeacher }) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <h3 className={styles.cardHeaderTitle}>Ссылки на сторонние ресурсы</h3>
      </div>

      <div className={`${styles.cardBody} ${styles.linksBody}`}>
        <ul className={styles.linksList}>
          {links &&
            links.map((link, index) => (
              <li key={index}>
                <a
                  className={styles.linkItem}
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div
                    className={styles.linkIcon}
                    style={{
                      backgroundImage: `url(${BACKEND_URL_PREFIX}${link.icon.substring(
                        link.icon.indexOf("/links")
                      )})`,
                    }}
                  />
                  <span className={styles.linkTitle}>{link.title}</span>
                </a>
              </li>
            ))}
        </ul>

        <div className={styles.reviewsWrap}>
          <NavLink className={styles.reviewsBtn} to="/reviews">
            <RiEyeLine size={14} />
            {isTeacher ? (
              "Просмотр отзывов"
            ) : (
              <span>
                Оценить преподавателя. <br /> Оставить анонимный отзыв.
              </span>
            )}
          </NavLink>
        </div>
      </div>
    </div>
  );
}
